// extracted by mini-css-extract-plugin
export default {"chatButton":"elb02pnDKjKhrw0tK5wX","openedChat":"DeBvhdSLJyD_iCHU21wm","chatImg":"TCV9Ss0R6BHniyoOtK88","unreadCount":"Z_myXdUgRs_ZU6ECChnP"};